/* import __COLOCATED_TEMPLATE__ from './worst-case-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();